import type { ExperienceAttributes } from '@atlassian/jira-experience-tracker/src/common/types.tsx';
import { useExperienceTracker } from '@atlassian/jira-software-logging/src/services/experience-tracker/index.tsx';
import {
	APP_ID,
	EPIC_PANEL_ASSIGN_EXPERIENCE,
	EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE,
	EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE,
	EPIC_PANEL_RANK_EXPERIENCE,
	EPIC_PANEL_UNASSIGN_EXPERIENCE,
	EPIC_PANEL_VIEW_EXPERIENCE,
	EXPERIENCE_TRACKER_PROVIDER_SOURCE,
} from '../../common/constants.tsx';

export const useViewEpicPanelExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_VIEW_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);

export const useInlineIssueCreateEpicPanelExperienceTracker = (
	attributes: ExperienceAttributes = {},
) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);

export const useGlobalIssueCreateEpicPanelExperienceTracker = (
	attributes: ExperienceAttributes = {},
) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);

export const useAssignEpicPanelExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_ASSIGN_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);

export const useUnassignEpicPanelExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_UNASSIGN_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);

export const useRankExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(
		APP_ID,
		EPIC_PANEL_RANK_EXPERIENCE,
		EXPERIENCE_TRACKER_PROVIDER_SOURCE,
		attributes,
	);
